module.exports = "../../../../platform/assets/pageMainIcon/icon-shuzhi-2-green.svg";